import { render, staticRenderFns } from "./elite_chat.vue?vue&type=template&id=f7caa9d0&scoped=true&"
import script from "./elite_chat.vue?vue&type=script&lang=js&"
export * from "./elite_chat.vue?vue&type=script&lang=js&"
import style0 from "./elite_chat.vue?vue&type=style&index=0&id=f7caa9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7caa9d0",
  null
  
)

export default component.exports